<p-button
  *ngIf="visible"
  [styleClass]="'mr-1 p-button-rounded p-button-secondary'"
  [icon]="'fa fa-ellipsis-v fa-fw'"
  (onClick)="tieredMenu.toggle($event)"
></p-button>
<p-tieredMenu
  #tieredMenu
  [model]="items"
  [popup]="true"
  [appendTo]="'body'"
></p-tieredMenu>
